import { useAtom } from '@reatom/npm-react'
import React from 'react'
import styled from 'styled-components'

import { ArrowLeftIcon, Button, useHapticFeedback } from '@blade/ui-kit'
import { settingScreenModeAtom } from '@root/features/settings/settings-screen'

type SettingsDrawerReturnProps = {
  onReturn?: () => void
}

export const SettingsDrawerReturn: React.FC<SettingsDrawerReturnProps> = ({
  onReturn,
}) => {
  const [screenMode] = useAtom(settingScreenModeAtom)
  const haptics = useHapticFeedback()

  if (screenMode === 'single-policy-screen' || !onReturn) {
    return undefined
  }

  return (
    <ButtonReturn
      variant="secondary"
      iconLeft={<ArrowLeftIcon />}
      size="xs"
      onClick={() => {
        haptics.impactOccurred('light')
        onReturn()
      }}
    />
  )
}

const ButtonReturn = styled(Button)`
  position: absolute;
  left: 15px;
  top: -31px;
`
